module.exports = new __parcel__URL__("hbo-max-logo.f9108cda.svg").toString();